import { createContext, useContext } from 'react';

interface QuestionCardStyle {
  bgGradientStart?: string;
  bgGradientEnd?: string;
  borderColor?: string;
  questionNumberBg?: string;
  questionNumberFg?: string;
  ddCardGradientStart?: string;
  ddCardGradientEnd?: string;
  ddCardBorderColor?: string;
  ddNumberBadgeBg?: string;
  ddNumberBadgeFg?: string;
  ddButtonBg?: string;
  ddButtonBorder?: string;
  ddBackgroundImage?: string;
  ddLogoImage?: string;
  ddSecondaryImage?: string;
}

const QuestionCardStyleContext = createContext<QuestionCardStyle>({});

export const QuestionCardStyleProvider = QuestionCardStyleContext.Provider;
export const useQuestionCardStyle = () => useContext(QuestionCardStyleContext);
